
































































import { Component, Vue } from 'vue-property-decorator';
import PaycheckStatus from '@/components/Paycheck/PaycheckStatus.vue';
import ShowPdfButton from '@/components/Invoicing/Shared/Buttons/ShowPdfButton.vue';
import PaycheckList from '@/components/Paycheck/PaycheckList.vue';
import formatPaycheckNumber from '@/filters/formatPaycheckNumber';

import { PAYCHECKS_SEARCH, PAYCHECK_PDF } from '@/queries/Paycheck';
import { GQL_PaycheckFilter } from '@/queries/global';
import Decimal from '@/utils/decimal';
import gql from 'graphql-tag';

const PAYCHECK_SUMMARY_REPORT = gql`
  query paychecksSummary(
    $filters: PaycheckFilter
  ) {
    paychecksSummary(
      filters: $filters
    ) {
      lines {
        number
        description
        sum
        car {
          id
          registrationNumber
        }
        department {
          id
          name
          code
        }
        project {
          id
          name
          code
        }
      }
    }
  },
`;

@Component({
  components: {
    ShowPdfButton,
    PaycheckStatus,
    PaycheckList,
  },
})
export default class Report extends Vue {
  private PAYCHECKS_SEARCH = PAYCHECKS_SEARCH;
  private PAYCHECK_SUMMARY_REPORT = PAYCHECK_SUMMARY_REPORT;
  private PAYCHECK_PDF = PAYCHECK_PDF;
  private formatPaycheckNumber = formatPaycheckNumber;
  private Decimal = Decimal;

  private paycheckSummaryFilters: GQL_PaycheckFilter = {};
}
